import {
  clearAllFlagOverrides,
  clearFlagOverride,
  setFlagOverride,
} from './overrides';
import { getFlags } from './reads';
import type { FlagType } from './types';

/** JS runtime type of an override value → the flag's {@link FlagType}. */
const flagTypeOf = (value: unknown): FlagType => {
  switch (typeof value) {
    case 'string':
      return 'string';
    case 'number':
      return 'number';
    case 'object':
      return 'object';
    default:
      return 'boolean';
  }
};

export interface FlagsConsoleApi {
  override: (key: string, value: boolean | string | number | object) => void;
  clear: (key: string) => void;
  clearAll: () => void;
  list: () => Record<string, unknown>;
}

/**
 * The console / automation surface for flags — override, clear, clearAll, list.
 * Backed by the override layer, so changes apply live with no config refetch.
 * `override` infers the flag's type from the value.
 *
 * Returns a plain object rather than attaching itself to a global: where it lives is
 * the host's call. portal exposes it as `window.__RSOS.flags`.
 */
export const getFlagsConsoleApi = (): FlagsConsoleApi => ({
  override: (key, value) => setFlagOverride(key, flagTypeOf(value), value),
  clear: clearFlagOverride,
  clearAll: clearAllFlagOverrides,
  list: getFlags,
});
